<template>
  <div class="oc-step-salary-branding">
    <div class="oc-step-header oc-step-header--compact mb-50">
      <div class="oc-step-header__icon oc-step-header__icon--compact">
        <feather-icon icon="LayersIcon" size="16" />
      </div>
      <div class="oc-step-header__body flex-grow-1">
        <div class="d-flex flex-wrap align-items-center justify-content-between">
          <div>
            <span class="oc-step-header__title">Salary &amp; branding</span>
            <span class="oc-step-header__hint">
              · Salary annexure table, logos &amp; letter images
            </span>
          </div>
          <b-badge variant="light-primary" class="oc-branding-count-badge ml-50 mt-25 mt-sm-0">
            {{ uploadedImageCount }} / {{ imageKeys.length }} images
          </b-badge>
        </div>
      </div>
    </div>

    <offer-configure-step-salary
      embedded
      :salary-section-included="salarySectionIncluded"
      :salary-parse-warning="salaryParseWarning"
      :salary-editor="salaryEditor"
      :active-structure-index="activeStructureIndex"
      :default-section-title-text="defaultSectionTitleText"
      :editor-disabled="editorDisabled"
      :section-layout-resolved="sectionLayoutResolved"
      :section-page-start-mode="sectionPageStartMode"
      @page-start-change="onPageStartChange"
      @section-layout-change="onSectionLayoutChange"
      @section-title-change="onSectionTitleChange"
      @section-title-font-size-change="onSectionTitleFontSizeChange"
      @section-title-font-weight-change="onSectionTitleFontWeightChange"
      @section-title-align-change="onSectionTitleAlignChange"
      @salary-input="onSalaryInput"
      @add-row="onAddRow"
      @remove-row="onRemoveRow"
      @move-row="onMoveRow"
      @add-structure="onAddStructure"
      @remove-structure="onRemoveStructure"
      @active-structure-change="onActiveStructureChange"
    />

    <hr class="oc-step-divider my-75">

    <offer-configure-step-branding
      embedded
      :form="form"
      :can-manage="canManage"
      :editor-disabled="editorDisabled"
      :uploaded-image-count="uploadedImageCount"
      :image-keys="imageKeys"
      :image-labels="imageLabels"
      :image-hints="imageHints"
      :image-icons="imageIcons"
      :section-layout-resolved="sectionLayoutResolved"
      @section-layout-change="onSectionLayoutChange"
      @image-upload="onImageUpload"
    />
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import OfferConfigureStepSalary from './OfferConfigureStepSalary.vue'
import OfferConfigureStepBranding from './OfferConfigureStepBranding.vue'

export default {
  name: 'OfferConfigureStepSalaryBranding',
  components: {
    BBadge,
    OfferConfigureStepSalary,
    OfferConfigureStepBranding,
  },
  props: {
    salarySectionIncluded: { type: Boolean, default: false },
    salaryParseWarning: { type: String, default: '' },
    salaryEditor: { type: Object, required: true },
    activeStructureIndex: { type: Number, default: 0 },
    defaultSectionTitleText: { type: Object, required: true },
    editorDisabled: { type: Boolean, default: false },
    sectionLayoutResolved: { type: Function, required: true },
    sectionPageStartMode: { type: Function, required: true },
    form: { type: Object, required: true },
    canManage: { type: Boolean, default: false },
    uploadedImageCount: { type: Number, default: 0 },
    imageKeys: { type: Array, required: true },
    imageLabels: { type: Object, required: true },
    imageHints: { type: Object, required: true },
    imageIcons: { type: Object, required: true },
  },
  methods: {
    // Re-emit via methods (not template arrow + $emit). Babel can compile
    // `(...args) => $emit('x', ...args)` to `$emit.apply(undefined, ...)`,
    // which throws: Cannot read properties of undefined (reading '_events').
    onPageStartChange(...args) {
      this.$emit('page-start-change', ...args)
    },
    onSectionLayoutChange(...args) {
      this.$emit('section-layout-change', ...args)
    },
    onSectionTitleChange(...args) {
      this.$emit('section-title-change', ...args)
    },
    onSectionTitleFontSizeChange(...args) {
      this.$emit('section-title-font-size-change', ...args)
    },
    onSectionTitleFontWeightChange(...args) {
      this.$emit('section-title-font-weight-change', ...args)
    },
    onSectionTitleAlignChange(...args) {
      this.$emit('section-title-align-change', ...args)
    },
    onSalaryInput(value) {
      this.$emit('salary-input', value)
    },
    onAddRow(...args) {
      this.$emit('add-row', ...args)
    },
    onRemoveRow(...args) {
      this.$emit('remove-row', ...args)
    },
    onMoveRow(...args) {
      this.$emit('move-row', ...args)
    },
    onAddStructure() {
      this.$emit('add-structure')
    },
    onRemoveStructure(index) {
      this.$emit('remove-structure', index)
    },
    onActiveStructureChange(index) {
      this.$emit('active-structure-change', index)
    },
    onImageUpload(...args) {
      this.$emit('image-upload', ...args)
    },
  },
}
</script>

<style scoped>
.oc-step-divider {
  border-color: #eef0f3;
}

.oc-branding-count-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
}
</style>
